import { ApiService } from "./api_service";

export class StatService extends ApiService {
    static getBillsStats(active_year, callback, callback_error) {
        this.executeGet(`stats/bills?active_year=${active_year}`, callback, callback_error);
    }
}